import React from 'react';
import {ReactComponent as Icon} from 'images/icon/trigger-trend.svg';

export default class extends React.PureComponent {
  render() {
    return <Icon className="icon trend" onClick={this.props.onClick} />;
  }
}
